import { store } from '@utils/configStore'
import { animeSubscriptionReducer } from './slices'

export const injectAnimeSubscriptionStore = () => store.injectReducer('animeSubscription', animeSubscriptionReducer)
